import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Courses", path: "/courses" },
    { name: "Internships", path: "/internships" },
    { name: "About", path: "/about" },
  ];

  const handleEnquiryScroll = () => {
    setOpen(false);
    navigate("/", { state: { scrollTo: "enquiry" } });
  };

  const mobileMenuVariants = {
    hidden: { height: 0, opacity: 0 },
    visible: {
      height: "auto",
      opacity: 1,
      transition: { duration: 0.3 },
    },
    exit: {
      height: 0,
      opacity: 0,
      transition: { duration: 0.2 },
    },
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <img
            src="/logo.png"
            alt="Logo"
            onClick={() => navigate("/")}
            className="h-12 md:h-14 w-auto cursor-pointer"
          />

          <nav className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `text-sm font-semibold transition ${
                    isActive
                      ? "text-indigo-600"
                      : "text-gray-800 hover:text-indigo-600"
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}

            <button
              onClick={handleEnquiryScroll}
              className="px-5 py-2 rounded-lg bg-indigo-600 text-white
                         text-sm font-semibold hover:bg-indigo-700 transition"
            >
              Enquire Now
            </button>
          </nav>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            variants={mobileMenuVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="md:hidden bg-white border-t"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {navLinks.map((link) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `text-base font-semibold ${
                      isActive
                        ? "text-indigo-600"
                        : "text-gray-800 hover:text-indigo-600"
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              ))}

              <button
                onClick={handleEnquiryScroll}
                className="mt-3 px-5 py-2 rounded-lg bg-indigo-600
                           text-white font-semibold hover:bg-indigo-700 transition"
              >
                Enquire Now
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
